import React, { useId } from 'react';
import './GlobalPencilLoader.css';

// The pencil writes a marking tick; its tip follows the same path the tick is drawn along.
const TICK_PATH = 'M22 58 L50 84 L120 18';

export default function GlobalPencilLoader({ text = 'Loading...', isInline = false, color = 'green' }) {
  // Gradient ids must be unique when several loaders render at once.
  const id = useId().replace(/:/g, '');

  return (
    <div
      className={`marksure-global-loader-overlay ${isInline ? 'is-inline' : ''} ${color === 'yellow' ? 'pencil-yellow' : ''}`}
      role="status"
      aria-live="polite"
      aria-label={text}
    >
      <div className="pencil-loader">
        <div className="pencil-loader-stage">
          <svg className="pencil-loader-tick" viewBox="0 0 140 100" aria-hidden="true">
            <defs>
              <linearGradient id={`${id}-ink`} x1="0" y1="1" x2="1" y2="0">
                <stop offset="0%" className="ink-start" />
                <stop offset="100%" className="ink-end" />
              </linearGradient>
            </defs>
            <path d={TICK_PATH} pathLength="1" stroke={`url(#${id}-ink)`} />
          </svg>

          <svg className="pencil-loader-pencil" viewBox="0 0 96 16" aria-hidden="true">
            <defs>
              <linearGradient id={`${id}-body`} x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" className="body-light" />
                <stop offset="45%" className="body-mid" />
                <stop offset="100%" className="body-dark" />
              </linearGradient>
              <linearGradient id={`${id}-metal`} x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#f8fafc" />
                <stop offset="50%" stopColor="#cbd5e1" />
                <stop offset="100%" stopColor="#8b97a8" />
              </linearGradient>
              <linearGradient id={`${id}-wood`} x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#f3c9a0" />
                <stop offset="100%" stopColor="#d08a55" />
              </linearGradient>
            </defs>
            {/* Graphite tip at x=0 so the tip sits exactly on the drawn line. */}
            <path d="M0 8 L7 5.2 L7 10.8 Z" fill="#2b2b2b" />
            <path d="M7 5.2 L20 1 L20 15 L7 10.8 Z" fill={`url(#${id}-wood)`} />
            <rect x="20" y="1" width="54" height="14" fill={`url(#${id}-body)`} />
            <rect x="20" y="1" width="54" height="2.2" fill="#ffffff" opacity="0.28" />
            <rect x="74" y="1" width="10" height="14" fill={`url(#${id}-metal)`} />
            <rect x="77" y="1" width="1.2" height="14" fill="#7c8796" opacity="0.6" />
            <rect x="80.5" y="1" width="1.2" height="14" fill="#7c8796" opacity="0.6" />
            <path d="M84 1 H92 A4 4 0 0 1 96 5 V11 A4 4 0 0 1 92 15 H84 Z" fill="#e88b8a" />
            <path d="M84 1 H92 A4 4 0 0 1 96 5 V6 H84 Z" fill="#ffffff" opacity="0.25" />
          </svg>

          <div className="pencil-loader-shadow" />
        </div>
        <p className="pencil-loader-text">{text}</p>
      </div>
    </div>
  );
}
